import React from "react";
import { Paperclip } from "lucide-react";
import Text from "@/components/ui/text";
import { SavedAttachmentInfo } from "@/entities/attachments/types";

interface AttachmentDisplayProps {
  attachments: SavedAttachmentInfo[];
  onRemoveAttachment: (attachmentId: string) => void;
}

const AttachmentDisplay: React.FC<AttachmentDisplayProps> = ({
  attachments,
  onRemoveAttachment
}) => {
  if (attachments?.length === 0) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {attachments?.map((attachment) => (
        <div
          key={attachment.id}
          className="flex items-center gap-1 px-2 py-1 bg-surface-elevation1 border border-border-border2 rounded text-sm"
        >
          <Paperclip size={12} className="shrink-0" />
          <Text variant="smBody" hasTruncatedTooltip className="truncate max-w-[12rem]">
            {attachment.filename}
          </Text>
          <button
            onClick={() => onRemoveAttachment(attachment.id)}
            className="ml-1 text-tertiary hover:text-primary transition-colors"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default AttachmentDisplay;
